import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import SettingProperties from "./setting-properties-text.mdx";
import NamingTip from "./naming-tip.mdx";
import Intro from "./intro.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Intro mdxType="Intro" />
    <pre><code parentName="pre" {...{
        "className": "language-rust"
      }}>{`let mut event = Event::new("user_signed_up", "distinct_id_of_the_user");
client.capture(event).unwrap();
`}</code></pre>
    <NamingTip mdxType="NamingTip" />
    <SettingProperties mdxType="SettingProperties" />
    <pre><code parentName="pre" {...{
        "className": "language-rust"
      }}>{`let mut event = Event::new("user_signed_up", "distinct_id_of_the_user");

event.insert_prop("login_type", "email").unwrap();
event.insert_prop("is_free_trial", true).unwrap();

client.capture(event).unwrap();
`}</code></pre>
    <h3 {...{
      "id": "batching-events"
    }}>{`Batching events`}</h3>
    <p>{`To capture multiple events at once, use `}<inlineCode parentName="p">{`batch()`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-rust"
      }}>{`let event1 = posthog_rs::Event::new("event 1", "distinct_id_of_user_A");
let event2 = posthog_rs::Event::new("event 2", "distinct_id_of_user_B");

client.capture_batch(vec![event1, event2]).unwrap();
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      